var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ride.text)?_c('section',{staticClass:"poster-story"},[_c('PosterClamp',{attrs:{"lines":6,"lineHeight":28}},[_c('div',{staticClass:"poster-story-text",domProps:{"innerHTML":_vm._s(_vm.ride.text)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }